import { render, staticRenderFns } from "./ResultProductCard.vue?vue&type=template&id=6127d043&scoped=true&"
import script from "./ResultProductCard.vue?vue&type=script&lang=js&"
export * from "./ResultProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ResultProductCard.vue?vue&type=style&index=0&id=6127d043&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6127d043",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
